import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
import querystringify from 'querystringify';
import { has, isEmpty, isNil, reduce, replace, startsWith, join } from 'lodash';

import HomeDecorator from '../HomeDecorator';
import { ROUTE_LOGIN, ROUTE_REDESIGN, ROUTE_SSO_AUTH_LINK } from '../../../constants/pathnames';
import { SSO_AUTH_TYPES, SSO_AUTH_KEYS } from '../../../constants/auth';

class SSOAuthLoadingView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect_to: '/',
      shouldReload: false,
    };
  }

  componentDidMount() {
    if (this.state.shouldReload === false) {
      this.setState({
        shouldReload: true,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //check if
    if (prevState.shouldReload === false && this.state.shouldReload === true) {
      const { idpConfig, history, ssoAuthError, ssoIdpAuthReceiveCode } = this.props;
      const qParams = querystringify.parse(this.props.location.search);
      //if url has qparams, set state for redirecting
      if (has(qParams, 'code') && has(qParams, 'state') && !isEmpty(qParams.state)) {
        //check state with saved state;
        //this is for oidc. similar check needed for saml

        if (has(idpConfig, 'authParams.nonce') && idpConfig.authParams.nonce === qParams.state) {
          ssoIdpAuthReceiveCode(qParams);
        } else {
          ssoAuthError();
        }
      } else if (has(qParams, 'response_type') && qParams.response_type === 'error') {
        const reason = has(qParams, 'reason') ? qParams.reason : null;
        ssoAuthError(reason);
      } else {
        const { cookies } = this.props;
        const allCookies = cookies.getAll();

        const samlTokenArray = reduce(
          allCookies,
          (acc, val, k) => {
            if (startsWith(k, 'saml_token-')) {
              let idx = replace(k, 'saml_token-', '');
              acc[idx] = val;
              cookies.remove(k);
            }
            return acc;
          },
          [],
        );

        const nex_token = cookies.get('nex_token') || null;

        if (!isEmpty(samlTokenArray)) {
          const saml_token = join(samlTokenArray, '');
          this.props.authWithSSO({
            saml_token,
            //redirect_to,
            type: SSO_AUTH_TYPES.saml,
            [SSO_AUTH_KEYS.nexla_token_url]: idpConfig.configInfo[SSO_AUTH_KEYS.nexla_token_url],
          });
        } else if (nex_token) {
          this.props.authWithSSO({
            nex_token,
            //redirect_to,
            type: SSO_AUTH_TYPES.saml,
            [SSO_AUTH_KEYS.nexla_token_url]: idpConfig.configInfo[SSO_AUTH_KEYS.nexla_token_url],
          });
          cookies.remove('nex_token');
        } else {
          ssoAuthError();
        }
      }

      history.push(ROUTE_SSO_AUTH_LINK);
    } else if (isNil(prevProps.session.error) && !isNil(this.props.session.error)) {
      const { history } = this.props;
      // if session resulted in error redirect to login page
      history.push(ROUTE_LOGIN);
    } else if (prevProps.userLoggedIn === false && this.props.userLoggedIn === true) {
      const { idpConfig, history } = this.props;
      const nextPath =
        has(idpConfig, 'nextPath') &&
        !isNil(idpConfig.nextPath) &&
        startsWith(idpConfig.nextPath, '/') &&
        !startsWith(idpConfig.nextPath, ROUTE_REDESIGN)
          ? idpConfig.nextPath
          : '/';
      history.push(nextPath);
    }
  }

  render() {
    const homeComponent = <div key="login" className="LoginForm" />;
    return HomeDecorator(homeComponent, null, true);
  }
}

export default withRouter(withCookies(SSOAuthLoadingView));
